
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[catalogInstance]",
      function () {
        return require("private-next-pages/c/[catalogInstance].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/[catalogInstance]"])
      });
    }
  